// import * as React from "react";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemText from "@mui/material/ListItemText";
// import CommentIcon from "@mui/icons-material/Comment";
// import IconButton from "@mui/material/IconButton";
import {
  upperFooterData,
  lowerFooterdata,
  // footerSocials,
} from "./footerConstants";
import { Divider } from "@mui/material";
import { Link } from "react-router-dom";
// import grl from "../../assets/grl.jpg";
// import dctlogo from "../../assets/dctlogo.png";
// import { MdOutlineMailOutline } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
// import { MdOutlineMail } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import { IoLogoWhatsapp } from "react-icons/io";

export default function Footer() {
  const locationData = [
    {
      address:
        "Main Street 1149, Riggins, Idaho County, Idaho, 83549, United States of America",
      country: "U.S.A",
      id: 1,
    },
    {
      address:
        "	47 Burnley Street, Blewitt Springs, South Australia, 5171, Australia",
      country: "Australia",
      id: 2,
    },
    {
      address: "Irish st Bunclody, Bunclody, County Wexford, Ireland",
      country: "Ireland",
      id: 3,
    },
    {
      address:
        "	Bei Zhan Bei Jie 7hao Hua Yuan Qi Ye Zhong Xin Ezuo Zhong Guo Dian Ying Gu Fen You Xian Gong Si 601shi, China",
      country: "Ireland",
      id: 4,
    },
    {
      address:
        "	70 rue de la Hulotais, Saint-raphaËl, Provence-Alpes-Côte d'Azur,France",
      country: "France",
      id: 5,
    },
  ];

  const content = (
    <footer className="min-h-full   md:px-[4rem]   pt-[1rem]  w-screen bg-black text-white   rounded-tr-[2rem]  ">
      <section className="min-w-[90%]  mx-auto">
        <div className="px-[1rem]">
          <ul className="flex flex-col justify-center  items-start  gap-[1rem] p-[0.3rem]">
            {locationData.map((data) => (
              <li key={data.id} className="text-[0.7rem]">
                <FaLocationDot className="inline-block" />{" "}
                <span className="font-medium  tracking-wide">
                  {data.country}
                </span>
                : <span>{data.address}</span>{" "}
              </li>
            ))}

            {/* whatsapp number */}
            <li className="text-[0.7rem]">
              <IoLogoWhatsapp className="inline-block" />{" "}
              <span className="font-medium  tracking-wide">Whatsapp</span>:{" "}
              <span className=" tracking-wide text-red-500">
                +447438898686
              </span>{" "}
            </li>

            {/* email */}

            <li className="text-[0.7rem]">
              <MdEmail className="inline-block" />{" "}
              <span className="font-medium  tracking-wide">Email</span>:{" "}
              <span className="underline  underline-offset-2 tracking-wide text-red-500">
                support@shippersroute.com
              </span>{" "}
            </li>
          </ul>
        </div>

        <ul className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 p-4">
          {upperFooterData.map((data) => (
            <li key={data.id}>
              <h4 className="font-bold  mb-[0.5rem] text-[#f1c24e]">
                {data.title}
              </h4>
              <ul className="flex flex-col justify-start  items-start  gap-[1rem]">
                {data.subData.map((sd) => (
                  <li key={sd.id}>
                    {" "}
                    <Link to={sd.url}> {sd.urlTitle}</Link>{" "}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </section>

      <section className="p-4">
        <Divider sx={{ my: "1rem" }} />
        {/* company logo */}
        {/* <img src={dctlogo} className="w-[40%] h-[40%]  mb-[3rem]" /> */}

        <div className="min-w-full   flex flex-col md:flex-row  justify-start items-start gap-[1.2rem]  md:gap-[6rem] ">
          <ul className="  grid grid-cols-1    gap-[3rem]">
            {lowerFooterdata.map((data) => (
              <li key={data.id}>
                <Link>{data.title}</Link>
              </li>
            ))}
          </ul>
          {/* footer socials links*/}
          {/* <div>
						<h5 className="font-bold tracking-wide  my-[1rem] ">Follow Us</h5>
						<ul className="  grid grid-cols-4    gap-[1.4rem]">
							{footerSocials.map((social) => (
								<li key={social.id} className="text-[2rem]">
									{social.icon}
								</li>
							))}
						</ul>
					</div> */}
        </div>

        <hr className="w-[80%]  mx-auto my-[2rem] text-gray-600  bg-gray-500" />

        <p className="w-fit  my-[1.5rem]  mx-auto  text-gray-400 text-[0.8rem]  text-center ">
          copyright &copy; Shippersroute Logistics. all rights reserved{" "}
        </p>
      </section>
    </footer>
  );

  return content;
}
